import { render, staticRenderFns } from "./safe-placeList.vue?vue&type=template&id=ca02c470&scoped=true&"
import script from "./safe-placeList.vue?vue&type=script&lang=js&"
export * from "./safe-placeList.vue?vue&type=script&lang=js&"
import style0 from "./safe-placeList.vue?vue&type=style&index=0&id=ca02c470&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca02c470",
  null
  
)

export default component.exports